import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Box,
  Typography,
  Autocomplete,
  TextField,
  CircularProgress,
  Select,
  MenuItem,
  ListItemText,
  Button,
  Paper, // Adicionado aqui
  Avatar,
} from "@mui/material";

import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ChatIcon from "@mui/icons-material/Chat";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useTheme } from "@material-ui/core/styles";


import { createFilterOptions } from "@material-ui/lab/Autocomplete";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import ContactModal from "../ContactModal";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import ShowTicketOpen from "../ShowTicketOpenModal";
import { toast } from "react-toastify";
const filter = createFilterOptions({ trim: true });

const NewTicketModal = ({ modalOpen, onClose, initialContact }) => {
  const history = useHistory();
  const [options, setOptions] = useState([]);
  const [channelFilter, setChannelFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState("");
  const [selectedWhatsapp, setSelectedWhatsapp] = useState("");
  const [newContact, setNewContact] = useState({});
  const [whatsapps, setWhatsapps] = useState([]);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const { whatsappId, companyId } = user;
  const theme = useTheme();


  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");
  useEffect(() => {
    if (initialContact?.id !== undefined) {
      setOptions([initialContact]);
      setSelectedContact(initialContact);
      setSearchParam(`${initialContact.name} - ${initialContact.number}`);
    }
  }, [initialContact]);

  useEffect(() => {
    if (!modalOpen) {
      setSearchParam("");
      setSelectedContact(null);
      setOptions([]);
    }
  }, [modalOpen]);


  useEffect(() => {
    setLoading(true);
    const delay = setTimeout(() => {
      const fetchWhatsapps = async () => {
        try {
          const { data } = await api.get("/whatsapp", {
            params: { companyId, session: 0 },
          });
          setWhatsapps(data);
        } catch (err) {
          toastError(err);
        }
      };

      if (whatsappId) setSelectedWhatsapp(whatsappId);
      if (user.queues.length === 1) setSelectedQueue(user.queues[0].id);
      fetchWhatsapps();
      setLoading(false);
    }, 500);
    return () => clearTimeout(delay);
  }, [selectedContact, channelFilter]);

  useEffect(() => {
    if (!modalOpen || searchParam.length < 3) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delay = setTimeout(async () => {
      try {
        const { data } = await api.get("contacts", {
          params: { searchParam },
        });
        // ✅ CORREÇÃO: Filtra apenas contatos individuais no autocomplete
        const individualContacts = data.contacts?.filter(contact => !contact.isGroup) || [];
        setOptions(individualContacts);
        setLoading(false);
      } catch (err) {
        toastError(err);
        setLoading(false);
      }
    }, 500);
    return () => clearTimeout(delay);
  }, [searchParam, modalOpen]);
  const handleClose = () => {
    onClose();
    setSearchParam("");
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
    setSelectedContact(null);
  };

  const handleSaveTicket = async (contactId) => {
    if (!contactId) return;
    if (selectedQueue === "") {
      toast.error("Selecione uma fila");
      return;
    }
  
    setLoading(true);
  
    try {
      const { data: ticket } = await api.post("/tickets", {
        contactId,
        queueId: selectedQueue,
        whatsappId: selectedWhatsapp,
        userId: user.id,
        status: "open",
      });
  
      onClose(ticket); // Sucesso: abre o ticket
    } catch (err) {
      const errorData = err.response?.data?.error;
  
      if (errorData && typeof errorData === "string") {
        try {
          const ticket = JSON.parse(errorData);
  
          console.log("🚨 DEBUG Ticket retornado:", ticket);
          console.log("👤 userId do ticket:", ticket?.userId);
          console.log("👤 user.id atual:", user?.id);
          
          if (ticket?.userId && ticket.userId !== user?.id) {
                      // Ticket está com outro atendente: mostra alerta
            setUserTicketOpen(ticket?.user?.name || "Outro atendente");
            setQueueTicketOpen(ticket?.queue?.name || "Fila não informada");
            setOpenAlert(true);
          } else {
            // Ticket é do próprio usuário: abre direto
            setOpenAlert(false);
            onClose(ticket);
          }
  
        } catch (parseError) {
          toastError("Já existe um ticket aberto com este contato.");
        }
      } else {
        toastError("Erro ao criar ticket.");
      }
    }
  
    setLoading(false);
  };
  
  const handleSelectOption = (e, newValue) => {
    if (newValue?.number) {
      setSelectedContact(newValue);
    } else if (newValue?.name) {
      setNewContact({ name: newValue.name });
      setContactModalOpen(true);
    }
  };
  const handleAddNewContactTicket = (contact) => {
    setSelectedContact(contact);
  };

  const handleStartDirectConversation = async (rawNumber) => {
    if (!rawNumber || selectedQueue === "" || selectedWhatsapp === "") {
      toast.warning("Preencha o número, fila e conexão para iniciar a conversa.");
      return;
    }

    setLoading(true);

    try {
      // Verifica se o contato já existe
      const { data: contact } = await api.get("/contacts", {
        params: { searchParam: rawNumber }
      });

      // ✅ CORREÇÃO: Filtra apenas contatos individuais, ignora grupos
      const selected = contact.contacts?.find(c => !c.isGroup);

      let contactToUse = selected;

      if (!selected) {
        // Se não existir, cria o contato
        const { data: newContact } = await api.post("/contacts", {
          name: rawNumber,
          number: rawNumber
        });
        contactToUse = newContact;
      }

      setSelectedContact(contactToUse);
      setSearchParam(`${contactToUse.name} - ${contactToUse.number}`);

      try {
        // Tenta criar o ticket
        await handleSaveTicket(contactToUse.id);
      } catch (err) {
        const errorData = err.response?.data?.error;
        try {
          const ticket = JSON.parse(errorData);

          if (ticket?.userId && ticket.userId !== user?.id) {
            setUserTicketOpen(ticket?.user?.name || "Outro atendente");
            setQueueTicketOpen(ticket?.queue?.name || "Fila");
            setOpenAlert(true);
          } else {
            onClose(ticket); // Se for do mesmo usuário, abre direto
          }
        } catch (parseErr) {
          toastError("Já existe um ticket aberto com este contato.");
        }
      }
    } catch (err) {
      toastError("Erro ao iniciar conversa.");
    } finally {
      setLoading(false);
    }
  };




  const renderContactAutocomplete = () => {
    const shouldShowActionButtons =
      !loading && searchParam.trim() !== "" && options.length === 0;

    return (
      <Grid item xs={12}>
        <Autocomplete
          fullWidth
          options={options}
          loading={loading}
          clearOnEscape
          freeSolo
          inputValue={searchParam}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onInputChange={(event, newInputValue, reason) => {
            if (reason !== "reset") {
              setSearchParam(newInputValue);
            }
          }}
          getOptionLabel={(option) =>
            typeof option === "string"
              ? option
              : option?.name && option?.number
                ? `${option.name} - ${option.number}`
                : ""
          }
          onChange={(e, newValue) => {
            if (newValue?.number) {
              setSelectedContact(newValue);
              setSearchParam(`${newValue.name} - ${newValue.number}`);
            } else if (newValue?.name) {
              setNewContact({ name: newValue.name });
              setContactModalOpen(true);
            }
          }}
          renderOption={(props, option) =>
            option.number ? (
              <li
                {...props}
                style={{
                  ...(props?.style || {}),
                  paddingTop: 8,
                  paddingBottom: 8,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <Box display="flex" alignItems="center" gap={1.5}>
                  <Avatar
                    src={option.urlPicture || option.profilePicUrl || "/nopicture.png"}
                    alt={option.name}
                    sx={{ width: 56, height: 56 }}
                  />
                  {renderIcon(option.channel)}
                  <Typography sx={{ ml: 1 }}>
                    {option.name} - {option.number}
                  </Typography>
                </Box>
              </li>
            ) : null
          }
          PaperComponent={(props) => (
            <Paper
              {...props}
              sx={{
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
              }}
            />
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Digite nome ou número"
              variant="outlined"
              autoFocus
              onKeyPress={(e) => {
                if (e.key === "Enter" && selectedContact) {
                  handleSaveTicket(selectedContact.id);
                }
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: theme.palette.inputBackground || (theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.background.paper),
                  color: theme.palette.text.primary,
                  borderRadius: '8px',
                  fontWeight: 500,
                  '& fieldset': {
                    borderColor: theme.palette.divider + ' !important',
                  },
                  '&:hover fieldset': {
                    borderColor: theme.palette.primary.main + ' !important',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: theme.palette.primary.main + ' !important',
                  },
                },
                '& .MuiOutlinedInput-input': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.secondary,
                  fontWeight: 500,
                },
                '& .MuiInputLabel-outlined': {
                  color: theme.palette.text.secondary,
                  fontWeight: 500,
                },
                '& .Mui-disabled': {
                  color: theme.palette.text.disabled,
                },
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading && <CircularProgress color="inherit" size={20} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
              InputLabelProps={{
                style: {
                  color: theme.palette.text.secondary,
                  fontWeight: 500,
                }
              }}
            />
          )}
        />
      </Grid>
    );
  };


  const renderIcon = (channel) => {
    switch (channel) {
      case "facebook":
        return <FacebookIcon sx={{ color: theme.palette.info.main }} />;
      case "instagram":
        return <InstagramIcon sx={{ color: theme.palette.secondary.main }} />;
      default:
        return <WhatsAppIcon sx={{ color: theme.palette.success.main }} />;
    }
  };

  const shouldShowActionButtons =
    !loading && searchParam.trim() !== "" && options.length === 0;

  return (
    <>
      <Dialog 
        open={modalOpen} 
        onClose={handleClose} 
        fullWidth 
        maxWidth="xs"
        PaperProps={{
          sx: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
          }
        }}
      >
        <DialogTitle sx={{ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary }}>
          <Box display="flex" alignItems="center" gap={1}>
            <ChatIcon sx={{ color: theme.palette.primary.main }} />
            <Typography variant="h6">Criar novo ticket</Typography>
          </Box>
        </DialogTitle>

        <DialogContent 
          dividers 
          sx={{ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary }}
        >
          <Grid container spacing={2} direction="column">
            {/* Campo de contato/número */}
            {renderContactAutocomplete()}

            {/* Fila */}
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor:
                    theme.palette.mode === "dark"
                      ? theme.palette.background.paper
                      : theme.palette.action.selected,
                  borderRadius: "8px",
                  padding: "8px 12px",
                  color: theme.palette.text.primary,
                }}
              >
                <Typography sx={{ fontWeight: "bold", color: theme.palette.text.primary }}>Fila:</Typography>
                <Box sx={{ flex: 1, ml: 2 }}>
                  <Select
                    fullWidth
                    value={selectedQueue}
                    onChange={(e) => setSelectedQueue(e.target.value)}
                    displayEmpty
                    variant="standard"
                    disableUnderline
                    sx={{
                      borderRadius: "999px",
                      fontWeight: "bold",
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.getContrastText(theme.palette.primary.main),
                      height: "32px",
                      px: 2,
                      '& .MuiSelect-select': {
                        padding: 0,
                        textAlign: "center",
                        color: theme.palette.getContrastText(theme.palette.primary.main),
                      },
                      '& .MuiSelect-icon': {
                        color: theme.palette.getContrastText(theme.palette.primary.main),
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          backgroundColor: theme.palette.background.paper,
                          color: theme.palette.text.primary,
                        }
                      }
                    }}
                    renderValue={() => {
                      if (!selectedQueue) return "Escolher";
                      const queue = user.queues.find((q) => q.id === selectedQueue);
                      return queue?.name || "Escolher";
                    }}
                  >
                    <MenuItem value="">
                      <em style={{ color: theme.palette.text.secondary }}>Nenhuma</em>
                    </MenuItem>
                    {user.queues.map((queue) => (
                      <MenuItem key={queue.id} value={queue.id} sx={{ color: theme.palette.text.primary }}>
                        {queue.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
            </Grid>

            {/* Conexão */}
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor:
                    theme.palette.mode === "dark"
                      ? theme.palette.background.paper
                      : theme.palette.action.selected,
                  borderRadius: "8px",
                  padding: "8px 12px",
                  color: theme.palette.text.primary,
                }}
              >
                <Typography sx={{ fontWeight: "bold", color: theme.palette.text.primary }}>Conexão:</Typography>
                <Box sx={{ flex: 1, ml: 2 }}>
                  <Select
                    fullWidth
                    value={selectedWhatsapp}
                    onChange={(e) => setSelectedWhatsapp(e.target.value)}
                    displayEmpty
                    variant="standard"
                    disableUnderline
                    sx={{
                      borderRadius: "999px",
                      fontWeight: "bold",
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.getContrastText(theme.palette.primary.main),
                      height: "32px",
                      px: 2,
                      '& .MuiSelect-select': {
                        padding: 0,
                        textAlign: "center",
                        color: theme.palette.getContrastText(theme.palette.primary.main),
                      },
                      '& .MuiSelect-icon': {
                        color: theme.palette.getContrastText(theme.palette.primary.main),
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          backgroundColor: theme.palette.background.paper,
                          color: theme.palette.text.primary,
                        }
                      }
                    }}
                    renderValue={() => {
                      if (!selectedWhatsapp) return "Escolher";
                      const whatsapp = whatsapps.find((w) => w.id === selectedWhatsapp);
                      return whatsapp?.name || "Escolher";
                    }}
                  >
                    <MenuItem value="">
                      <em style={{ color: theme.palette.text.secondary }}>Nenhuma</em>
                    </MenuItem>
                    {whatsapps.map((w) => (
                      <MenuItem key={w.id} value={w.id} sx={{ color: theme.palette.text.primary }}>
                        {w.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
            </Grid>

            {/* Botões de ação */}
            <Grid item xs={12}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Button
                  variant="outlined"
                  fullWidth
                  sx={{
                    borderColor: theme.palette.divider,
                    color: theme.palette.text.secondary,
                    fontWeight: 700,
                    borderRadius: 2,
                    '&:hover': {
                      borderColor: theme.palette.primary.main,
                      backgroundColor: theme.palette.action.hover,
                      color: theme.palette.primary.main,
                    },
                    '& .MuiButton-startIcon': {
                      color: theme.palette.text.secondary,
                    },
                  }}
                  startIcon={<PersonAddIcon />}
                  disabled={!shouldShowActionButtons}
                  onClick={() => setContactModalOpen(true)}
                >
                  Adicionar novo contato
                </Button>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.getContrastText(theme.palette.primary.main),
                    fontWeight: 700,
                    borderRadius: 2,
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  }}
                  startIcon={<ChatIcon sx={{ color: theme.palette.getContrastText(theme.palette.primary.main) }} />}
                  disabled={!searchParam || selectedQueue === ""}
                  onClick={() =>
                    handleStartDirectConversation(
                      selectedContact?.number || searchParam.replace(/\D/g, "")
                    )
                  }
                >
                  INICIAR CONVERSA COM ESTE NÚMERO
                </Button>

              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        {/* Sem botão "Salvar" no DialogActions */}
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              borderColor: theme.palette.divider,
              color: theme.palette.text.secondary,
              fontWeight: 700,
              borderRadius: 2,
              '&:hover': {
                borderColor: theme.palette.primary.main,
                backgroundColor: theme.palette.action.hover,
                color: theme.palette.primary.main,
              },
            }}
            disabled={loading}
          >
            Cancelar
          </Button>
        </DialogActions>

        {/* Modais adicionais */}
        {contactModalOpen && (
          <ContactModal
            open={contactModalOpen}
            initialValues={newContact}
            onClose={() => setContactModalOpen(false)}
            onSave={handleAddNewContactTicket}
          />
        )}

        {openAlert && (
          <ShowTicketOpen
            isOpen={openAlert}
            handleClose={() => setOpenAlert(false)}
            user={userTicketOpen}
            queue={queueTicketOpen}
          />
        )}
      </Dialog>

    </>
  );
};

export default NewTicketModal;
